import FutureVisits from './FutureVisits'

export default FutureVisits
